import { useCurrentTracking } from './use-current-tracking';
export function usePackageId() {
  var _useCurrentTracking$i, _useCurrentTracking;

  return (_useCurrentTracking$i = (_useCurrentTracking = useCurrentTracking()) === null || _useCurrentTracking === void 0 ? void 0 : _useCurrentTracking.id) !== null && _useCurrentTracking$i !== void 0 ? _useCurrentTracking$i : undefined;
}